import React from "react";
import { useTranslation } from "react-i18next";
import { TeamSection } from "./TeamSection";
import { Team, Tournament } from "@gp/models";
import { IGoalDistribution } from "@data-types/sport-stats/SportStatsTypes";

export const GoalDistribution = (props: {
	title: string;
	data: IGoalDistribution;
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) => {
	const { t } = useTranslation();

	if (!props.data) return null;

	return (
		<div className="card card--raised card--stats">
			<div className="card__header card--stats__header">
				<div className="card__title card__title--base card--stats__heading">
					{t(props.title)}
				</div>
			</div>

			<div className="card--stats__body">
				{props.data?.homeTeam && (
					<TeamSection
						teamData={props.data?.homeTeam}
						mainTeam={props.homeTeam}
						opponentTeam={props.awayTeam}
						label={t("EVENT.OFFER.COMPETITOR_HOME")}
						tournament={props.tournament}
						className={
							props.data?.awayTeam ? "u-mar--bottom--reset" : ""
						}
					/>
				)}

				{props.data?.awayTeam && (
					<TeamSection
						teamData={props.data?.awayTeam}
						mainTeam={props.awayTeam}
						opponentTeam={props.homeTeam}
						label={t("EVENT.OFFER.COMPETITOR_AWAY")}
						tournament={props.tournament}
					/>
				)}
			</div>
		</div>
	);
};
